/**
 * Structural view of a mouse click for link-handling decisions. Kept free of React/DOM types so
 * the logic is unit-testable with plain objects.
 */
export interface MouseClickLike {
    defaultPrevented: boolean
    button: number
    metaKey: boolean
    ctrlKey: boolean
    shiftKey: boolean
    altKey: boolean
}

/**
 * True when a click should be left to the browser's native link handling (open in new tab/window,
 * download, etc.) instead of being intercepted for SPA navigation: modified clicks
 * (ctrl/cmd/shift/alt), non-primary buttons (middle click), or events something else already
 * handled. Action Item 6751: intercepting these prevented users from opening Work Orders in new
 * tabs.
 */
export function isBrowserHandledClick(ev: MouseClickLike): boolean {
    return ev.defaultPrevented || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey
}
